import { useEffect } from 'react'
import { SheetHeader } from '../components/SheetHeader'
import { TitleSheet } from '../components/TitleSheet'
import { Register } from '../components/Register'
import { Legend } from '../components/Legend'
import { Traverse } from '../components/Traverse'
import { Models } from '../components/Models'
import { Notes } from '../components/Notes'
import { Authority } from '../components/Authority'
import { ClosingBlock } from '../components/ClosingBlock'
import { SheetMargin } from '../components/SheetMargin'

/*
THESIS: Passwork's method is the document it produces — a measured sheet precise enough to build from and hand over. Refuses the agency dark-gradient hero with three service cards.
OWN-WORLD: Survey sheet. Cool white ground #fbfcfb, buff land #e5ddc8, navy ink #12283c, one magenta overprint #cf1b6b reserved for actions and cautions. Archivo condensed caps, Spline Sans Mono for data. Hairline rules and ruled cells only — no cards, no shadows.
STORY: The visitor reads a real engineering document, follows the traverse from discovery to handover, believes the work is measured and handed back, and emails contact@passwork.ae.
FIRST VIEWPORT: Coordinate strip and sheet index across the top; left half a ruled title block — sheet title, two cells of copy, magenta stamp carrying the email; right half a quiet chart field with the traverse through ST-01/02/03; the register's first rules cut off at the bottom edge.
FORM: Survey Sheet, grounded candidate 7, seed 540c1d3d.
FINISH: unreviewed and undocumented is unfinished; this build ends with the finish review, the verdict, and DESIGN.md
*/

export function Home() {
  useEffect(() => {
    document.title =
      'Passwork Software Solution — Custom Software Development with AI'
    const meta = document.querySelector('meta[name="description"]')
    if (meta) {
      meta.setAttribute(
        'content',
        'Passwork Software Solution — custom software development with AI. Production systems surveyed, built, and handed over. Ras al Khaimah, United Arab Emirates.',
      )
    }
  }, [])

  return (
    <>
      <SheetHeader />
      <main>
        <TitleSheet />
        <Register />
        <Legend />
        <Traverse />
        <Models />
        <Notes />
        <Authority />
        <ClosingBlock />
      </main>
      <SheetMargin />
    </>
  )
}
